import React from 'react'

const AchievementList = ({
    title,
    date,
    link
}) => {
    return <li class="relative mb-6 sm:mb-0">
        <div class="flex items-center">
            <div class="flex z-10 justify-center items-center w-6 h-6 bg-red-300 rounded-full ring-0 ring-light  sm:ring-8  shrink-0">
                <svg class="w-3 h-3 text-danger " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path></svg>
            </div>
            <div class="hidden sm:flex w-full bg-light h-0.5 "></div>
        </div>
        <div class="mt-5 sm:pr-8">
            <h3 class="text-lg font-semibold text-light ">{title}</h3>
            <time class="block mb-2  text-sm font-normal leading-none text-light ">{date}</time>
            <a target="_blank" href={link} class="inline-flex items-center gap-x-3 py-2 px-4 mt-3 text-sm font-medium text-dark bg-light rounded-lg border  hover:bg-danger hover:text-light focus:z-10 focus:ring-4 focus:outline-none  "><i class="fa-solid fa-eye"></i>Certificate</a>
        </div>
    </li>
}

export default AchievementList